import './app.css';
import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { applyLangGuard } from './i18n/lang-guard';
import { initErrorCapture } from './lib/errorCapture';
import { initNetworkCapture } from './lib/networkCapture';

/**
 * Client entry.
 *
 * Mounts the React Router 7 shell. Service-worker registration is owned by
 * Plan 01-15's `useSwUpdate()` hook called from inside `App.tsx` — that
 * single call wires both the controllerchange reload guard (Plan 08) AND
 * the `onNeedRefresh` callback that drives the FND-02 update UX
 * (banner / tablet auto-reload). Plan 08 originally fired a bare
 * `registerSW()` here; Plan 15 moved that responsibility into App.tsx so
 * the registration is paired with its update-handling callbacks.
 */

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root missing from index.html');
}

// Lock `<html lang="nb">` before React mounts (FND-07, MED-7). Guard stays
// live via MutationObserver so a browser-extension or third-party script
// can't silently flip the page to auto-translate English.
applyLangGuard();

// Feedback widget diagnostics: buffer console errors + network calls from the
// very first paint so a bug report carries the context that led up to it.
// Both no-op under MODE === 'test' and always chain to the originals.
initErrorCapture();
initNetworkCapture();

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
